<template>
    <div class="h-nav">
        <span class="h-nav-item" v-for="item in menuList" :key="item.id" :class="{'active': item.id == activeId}">
            <router-link class="h-nav-item-link h-link" :to="'w'+item.id"
                         :class="{'router-link-active': item.id == activeId}">
                <span>{{ item.name }}</span>
            </router-link>&nbsp;
        </span>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: "TopMenu",
    props: {
        type: {
            default() {
                return 'public'
            },
        }
    },
    data: () => {
        return {

        }
    },
    created() {
    },
    mounted() {
        this.$nextTick(()=>{
            this.fetchData();
        })
    },
    computed: {
        ...mapState({
            menuList: state => state.menus.itemsTop,
            user: state => state.auth.user,
        }),
        activeId() {
            let id = '';

            if (this.$route) {
                id = this.$route.path;
            }

            if (typeof id !== 'undefined') {
                id = id.split('/')[1].replace('w','');
            }

            if (!id && Object.values(this.menuList)[0]) {
                for(let m in this.menuList){
                    if(this.user.id == this.menuList[m].userId){
                        id = this.menuList[m].id;
                    }
                }
            }

            return id;
        }
    },
    methods: {
        fetchData() {
            this.$store.dispatch('menus/getMenu');
        },
    }
}
</script>
<style>
    #nav .router-link-active {
        color: #42b983;
    }
</style>
